import React from "react";
import {Col, Container, Row} from "react-bootstrap";

const storiesgcc = () => {
  return (
    <div className="normal_section p-100">
      <Container className="h-100">
        <Row className="h-100">
          <Col xs={12} md={6} lg={6} xl={6} xxl={6} className="my-auto">
            <h2>Our Credibility Defined by Our Mobile App Development Success Stories </h2>
          </Col>
          <Col xs={12} md={6} lg={6} xl={6} xxl={6} className="my-auto">
            <p>
            TekRevol, an international mobile app development company, stands out for its cutting-edge solutions that drive global businesses forward. Our track record of success spans diverse industries, a testament to our high-tech capabilities. Through unwavering determination and an innovative mindset, we have earned our reputation. It is with great pride that we showcase our proven solutions, inviting you to explore our detailed case studies below:
            </p>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default storiesgcc;
